import React, { useState } from 'react';
import { Box, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { DragIndicator, ImageNotSupported } from '@mui/icons-material';

const useStyles = makeStyles(() => ({
    container: {
        display: 'flex',
        alignItems: 'stretch',
        gap: '12px',
        backgroundColor: '#fff',
        borderRadius: '8px',
        overflow: 'hidden',
        border: '1px solid #e0e0e0',
        boxShadow: '0 5px 15px rgba(0,0,0,0.3)',
    },
    dragHandle: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minWidth: '48px',
        backgroundColor: '#f5f5f5',
        color: '#999',
    },
    imageSection: {
        width: '120px',
        minWidth: '120px',
        height: '120px',
        backgroundColor: '#f5f5f5',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        overflow: 'hidden',
    },
    image: {
        width: '100%',
        height: '100%',
        objectFit: 'cover',
    },
    contentSection: {
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        padding: '12px 16px',
        minWidth: 0,
    },
    title: {
        fontFamily: "'GucciSans-Bold' !important",
        fontSize: '14px',
        fontWeight: 'bold',
        marginBottom: '8px',
        wordBreak: 'break-word',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        display: '-webkit-box',
        WebkitLineClamp: 2,
        WebkitBoxOrient: 'vertical',
    },
}));

export default function ImageDragPreview({ image }) {
    const classes = useStyles();
    const [imageError, setImageError] = useState(false);

    return (
        <Box className={classes.container}>
            <Box className={classes.dragHandle}>
                <DragIndicator />
            </Box>

            <Box className={classes.imageSection}>
                {!imageError && (image.thumbUrl || image.imageUrl) ? (
                    <img
                        src={image.thumbUrl || image.imageUrl}
                        alt={image.name}
                        className={classes.image}
                        onError={() => setImageError(true)}
                    />
                ) : (
                    <Box sx={{ textAlign: 'center', color: '#ccc' }}>
                        <ImageNotSupported sx={{ fontSize: '32px' }} />
                    </Box>
                )}
            </Box>

            <Box className={classes.contentSection}>
                <Typography className={classes.title}>
                    {image.name}
                </Typography>
            </Box>
        </Box>
    );
}